module.exports = __webpack_public_path__ + "img/portret.a2341615.png";